var $ = require('jquery');

console.log("yo");



//////////////////
// WEBPACK FOOTER
// ./views/js/activities.js
// module id = 11
// module chunks = 9